export function isDevelopmentEnvironment(): boolean {
    return document.body.classList.contains('develop');
}
